import { AppVideo } from 'appLanding/components/AppVideo';
import { KeyFeatures } from 'appLanding/components/KeyFeatures';

const AppLandingPage = () => (
  <>
    <AppVideo />
    <KeyFeatures />
  </>
);

export default AppLandingPage;
